module.exports = __webpack_public_path__ + "static/img/six2.b11eceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/six2.png
// module id = mLX5
// module chunks = 25